<template>
  <p
    class="content_text"
    :class="[!isInTable ? 'content_w_710' : 'content_table', device.isMobile ? 'content_mobile' : '']"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      marginTop: (typeof content.textStyle.marginTop === 'number' && (content.textStyle.marginTop + 'rem')) || '',
      marginBottom: (typeof content.textStyle.marginBottom === 'number' && (content.textStyle.marginBottom + 'rem')) || '',
      padding: (typeof content.textStyle.padding === 'number' && (content.textStyle.padding + 'rem')) || '',
    }"
  > 

    <i class="pop-box" v-if="content.showAnswerPop">
      <popover :content="content.answerPopContent">
        <template #popContent>
          <div class="pop-icon"></div>
        </template>
      </popover>
    </i>
    <template v-for="item in content.content">
      <textComponent :key="item.key" v-if="item.category === 'text'" :content="item"></textComponent>
      <linkComponent :key="item.key" v-if="item.category === 'link'" :content="item"></linkComponent>
      <popover :key="item.key" v-if="item.category === 'popover'" :content="item"></popover>
      <videoComponent :key="item.key" v-if="item.category === 'video'" :content="item"></videoComponent>
      <audioComponent :key="item.key" v-if="item.category === 'audio'" :content="item"></audioComponent>
      <imageComponent :key="item.key" v-if="item.category === 'image'" :content="item"></imageComponent>
      <inputComponent :key="item.key" v-if="item.category === 'input'" :content="item"></inputComponent>
      <wordDetailsComponent :key="item.key" v-if="item.category === 'wordDetails'" :content="item"></wordDetailsComponent>
    </template>
    <img :src="require('@/assets/images/books/bookExample/reset.png')" alt="" v-if="content&&content.isRefresh" style="width:34rem;height:34rem;cursor: pointer;float:right;margin-top:5rem;" @click.stop="resetClick">
  </p>
</template>
<script>
/*
正文组件
*/
import textComponent from "./text.vue";
import linkComponent from "./link.vue";
import popover from "./popover.vue";
import videoComponent from "./video.vue";
import audioComponent from "./audio.vue";
import imageComponent from "./image.vue";
import inputComponent from "./input.vue";
import wordDetailsComponent from "./wordDetails.vue"
export default {
  name: "textIndex",
  components: {
    textComponent,
    linkComponent,
    popover,
    videoComponent,
    audioComponent,
    imageComponent,
    inputComponent,
    wordDetailsComponent,//英语单词详情
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isInTable: {
      type: Boolean,
      default: false
    }
  },
  provide(){
    return {
      resetTo:false
    }
  },
  methods:{
    resetClick(){
      if(this.content.answerType==1){
        const elements = document.getElementsByClassName('span-input');
        // 遍历所有匹配的元素
        for (let i = 0; i < elements.length; i++) {
          // 清空每个元素的内容
          elements[i].innerHTML = '';
        }
      }else if(this.content.answerType==2){
        this.$bus.$emit("resetsss", this.content.key);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 0rem auto;
}
.content_text{
  font-size: 18rem;
  color: #1A1A1A;
  position: relative;
  text-align: left;

  span{
    user-select: text;
  }
  
  .pop-box{
    width: 30rem;
    height: 30rem;
    position: absolute;
    top: 8rem;
    left: 0;

    .pop-icon{
      width: 30rem;
      height: 30rem;
      background: url(~@/assets/images/books/book2/key-icon.png) center center no-repeat;
      background-size: contain;
    }
  }
}
.content_mobile{
  font-size: 28rem;
  line-height: 48rem;
}
.content_table{
  user-select: text;
}
</style>